import {
    createBottomTabNavigator
} from "@react-navigation/bottom-tabs";
import {
    createNativeStackNavigator
} from "@react-navigation/native-stack";
import {
    Home,
    Compass,
    UserRoundSearch
} from "lucide-react-native";
import {
    TabBar
} from "../../components";
import AboutPresident from "../../pages/app/aboutPresident";
import AboutUs from "../../pages/app/aboutUs";
import Announcements from "../../pages/app/announcements";
import AnnouncementDetail from "../../pages/app/announcements/announcementsDetail";
import ApplyForm from "../../pages/app/applyForm";
import BoardDirectors from "../../pages/app/boardDirectors";
import CampaignManagement from "../../pages/app/campaignManagement";
import CampaingDetail from "../../pages/app/campaignManagement/views/campaingDetail";
import CreateCampaign from "../../pages/app/campaignManagement/views/createCampaign";
import EditCampaign from "../../pages/app/campaignManagement/views/editCampaign";
import CompanyDetail from "../../pages/app/companyDetail";
import ContactFormForMembers from "../../pages/app/contactFormForMembers";
import EditProfile from "../../pages/app/editProfile";
import DeleteAccount from "../../pages/app/editProfile/views/deleteAccount";
import EditProfileUpdateRequest from "../../pages/app/editProfile/views/editProfileUpdateRequest";
import EventDetail from "../../pages/app/eventDetail";
import Explore from "../../pages/app/explore";
import HomeScreen from "../../pages/app/home";
import KVKK from "../../pages/app/kvkk";
import MemberPolicy from "../../pages/app/memberPolicy";
import News from "../../pages/app/news";
import NewsDetail from "../../pages/app/news/newsDetail";
import Notifications from "../../pages/app/notifications";
import OldPresidents from "../../pages/app/oldPresidents";
import PrivacyPolicy from "../../pages/app/privacyPolicy";
import Profile from "../../pages/app/profile";
import CompanyEdit from "../../pages/app/profile/views/companyEdit";
import CompanyEditView from "../../pages/app/profile/views/companyEditView";
import CreateCompany from "../../pages/app/profile/views/createCompany";
import MyCompanies from "../../pages/app/profile/views/myCompanies";
import ScanQR from "../../pages/app/scanQR";
import ThreeTTableInfo from "../../pages/common/threeTTableInfo";
import SearchPage from "../../pages/app/searchPage";
import UserProfile from "../../pages/app/userProfile";

const Tab = createBottomTabNavigator();
const Stack = createNativeStackNavigator();
const HomeStack = createNativeStackNavigator();

const AppTabs = () => {
    return  <Tab.Navigator
        initialRouteName="HomeTab"
        tabBar={(props) => <TabBar
            {...props}
        />}
        screenOptions={{
            headerShown: false
        }}
    >
        <Tab.Screen
            name="HomeTab"
            component={HomeStackNav}
            options={{
                tabBarLabel: "Ana Sayfa",
                tabBarIcon: ({
                    color,
                    size
                }) => <Home
                    color={color}
                    size={size}
                    strokeWidth={2.3}
                />
            }}
        />
        <Tab.Screen
            name="ExploreTab"
            component={Explore}
            options={{
                tabBarLabel: "Keşfet",
                tabBarIcon: ({
                    color,
                    size
                }) => <Compass
                    color={color}
                    size={size}
                    strokeWidth={2.3}
                />
            }}
        />
        <Tab.Screen
            name="SearchTab"
            component={SearchPage}
            options={{
                tabBarLabel: "Üye Arama",
                tabBarIcon: ({
                    color,
                    size
                }) => <UserRoundSearch
                    color={color}
                    size={size}
                    strokeWidth={2.3}
                />
            }}
        />
    </Tab.Navigator>;
};

const HomeStackNav = () => {
    return <HomeStack.Navigator
        initialRouteName="Home"
        screenOptions={{
            headerShown: false
        }}
    >
        <HomeStack.Screen
            name="Home"
            component={HomeScreen}
        />
        <HomeStack.Screen
            name="News"
            component={News}
        />
        <Stack.Screen
            name="Announcements"
            component={Announcements}
        />
    </HomeStack.Navigator>;
};

const AppStack = () => {
    return <Stack.Navigator
        screenOptions={{
            headerShown: false
        }}
    >
        <Stack.Screen
            name="MainTabs"
            component={AppTabs}
        />
        <Stack.Screen
            name="UserProfile"
            component={UserProfile}
        />
        <Stack.Screen
            name="EditProfile"
            component={EditProfile}
        />
        <Stack.Screen
            name="EditProfileUpdateRequest"
            component={EditProfileUpdateRequest}
        />
        <Stack.Screen
            name="CompanyDetail"
            component={CompanyDetail}
        />
        <Stack.Screen
            name="AboutUs"
            component={AboutUs}
        />
        <Stack.Screen
            name="BoardDirectors"
            component={BoardDirectors}
        />
        <Stack.Screen
            name="PrivacyPolicy"
            component={PrivacyPolicy}
        />
        <Stack.Screen
            name="MemberPolicy"
            component={MemberPolicy}
        />
        <Stack.Screen
            name="KVKK"
            component={KVKK}
        />
        <Stack.Screen
            name="OldPresidents"
            component={OldPresidents}
        />
        <Stack.Screen
            name="Profile"
            component={Profile}
        />
        <Stack.Screen
            name="AboutPresident"
            component={AboutPresident}
        />
        <Stack.Screen
            name="CompanyEdit"
            component={CompanyEdit}
        />
        <Stack.Screen
            name="CompanyEditView"
            component={CompanyEditView}
        />
        <Stack.Screen
            name="CreateCompany"
            component={CreateCompany}
        />
        <Stack.Screen
            name="CampaignManagement"
            component={CampaignManagement}
        />
        <Stack.Screen
            name="CreateCampaign"
            component={CreateCampaign}
        />
        <Stack.Screen
            name="EditCampaign"
            component={EditCampaign}
        />
        <Stack.Screen
            name="DeleteAccount"
            component={DeleteAccount}
        />
        <Stack.Screen
            name="MyCompanies"
            component={MyCompanies}
        />
        <Stack.Screen
            name="EventDetail"
            component={EventDetail}
        />
        <Stack.Screen
            name="ApplyForm"
            component={ApplyForm}
        />
        <Stack.Screen
            name="NewsDetail"
            component={NewsDetail}
        />
        <Stack.Screen
            name="CampaingDetail"
            component={CampaingDetail}
        />
        <Stack.Screen
            name="AnnouncementDetail"
            component={AnnouncementDetail}
        />
        <Stack.Screen
            name="ContactFormForMembers"
            component={ContactFormForMembers}
        />
        <Stack.Screen
            name="Notifications"
            component={Notifications}
        />
        <Stack.Screen
            name="ScanQR"
            component={ScanQR}
        />
        <Stack.Screen
            name="ThreeTTableInfo"
            component={ThreeTTableInfo}
        />
    </Stack.Navigator>;
};
export default AppStack;
